import React from 'react'
import { connect } from 'react-redux'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import $ from 'jquery'

import CreateEditScope from './CreateEditScope'
import EditScopeTabs from './EditScopeTabs'
import EditScopeTabQuestions from './EditScopeTabQuestions'
import EditScopeTabQuestionOptions from './EditScopeTabQuestionOptions'

import { clearNoDataError } from '../../GlobalStateContainer/actions'

import {
    fetchScopesList,
    fetchScopeError,
    fetchScope,
    createScope,
    deleteScope,
    updateScope,
    errorScope,

    fetchScopeTabsList,
    fetchScopeTabsError,
    deleteTab,
    updateScopeTabs,
    updateScopeTab,
    errorScopeTabs,

    fetchScopeQuestionsList,
    fetchScopeQuestionsError,
    deleteQuestion,
    addTabQuestion,
    updateTabQuestionDetail,

    addTabQuestionOption,
    updateTabQuestionDetailOption,
    deleteOption
} from './actions'

import CommError from '../../Shared/Errors/Errors'
import ConfirmModal from '../../Shared/ConfirmModal/ConfirmModal'

import './Scope.css'
import { setTimeout } from 'timers';

var Spinner = require('react-spinkit');

let chkReturn = 0;

class Scope extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            scope: {
                projectTypeId: 0,
                active: false,
                name: "",
                order: 0,
                instructions: "",
                parties: "",
                proposal: "",
                deleted: false
            },
            sortBy: "",
            sortOrder: "Ascending",

            confirmDelete: false,
            confirmDeleteTab: false,
            confirmDeleteQuestion: false,
            confirmDeleteQuestionOption: false,

            questionindex: -1,

            instructions: {}
        };

        this.afterOpen = this.afterOpen.bind(this);

        this.scopeView = this.scopeView.bind(this);

        this.scopeEdit = this.scopeEdit.bind(this);
        this.scopeEditVerify = this.scopeEditVerify.bind(this);

        this.scopeCreate = this.scopeCreate.bind(this);

        this.scopeDelete = this.scopeDelete.bind(this);
        this.scopeDeleteVerify = this.scopeDeleteVerify.bind(this);

        this.updateScope = this.updateScope.bind(this);
        this.updateScopeEdit = this.updateScopeEdit.bind(this);

        this.cancelScope = this.cancelScope.bind(this);
        this.closeScope = this.closeScope.bind(this);
        this.closeScopeEdit = this.closeScopeEdit.bind(this);

        this.sortColumn = this.sortColumn.bind(this);

        this.fetchScopeErrorClear = this.fetchScopeErrorClear.bind(this);
        this.errorScopeClear = this.errorScopeClear.bind(this);
        this.errorNoDataClear = this.errorNoDataClear.bind(this);

        this.instructionsChange = this.instructionsChange.bind(this);
        this.instructionsChangeQuestions = this.instructionsChangeQuestions.bind(this);
        this.partiesChange = this.partiesChange.bind(this);
        this.proposalChange = this.proposalChange.bind(this);

        // tabs
        this.tabDelete = this.tabDelete.bind(this);
        this.tabDeleteVerify = this.tabDeleteVerify.bind(this);

        this.scopeEditTabs = this.scopeEditTabs.bind(this);
        this.scopeEditTabsVerify = this.scopeEditTabsVerify.bind(this);

        this.updateScopeTabs = this.updateScopeTabs.bind(this);
        this.updateScopeDetailTab = this.updateScopeDetailTab.bind(this);

        this.cancelScopeTabs = this.cancelScopeTabs.bind(this);
        this.closeScopeTab = this.closeScopeTab.bind(this);
        this.closeScopeTabsAdd = this.closeScopeTabsAdd.bind(this);

        this.fetchScopeTabsErrorClear = this.fetchScopeTabsErrorClear.bind(this);
        this.errorScopeTabsClear = this.errorScopeTabsClear.bind(this);

        this.startTab = this.startTab.bind(this);
        this.stopTab = this.stopTab.bind(this);

        this.saveTab = this.saveTab.bind(this);
        this.saveDetailTab = this.saveDetailTab.bind(this);

        this.startViewTab = this.startViewTab.bind(this);
        this.startViewTabVerify = this.startViewTabVerify.bind(this);
 
        // questions
        this.fetchScopeQuestionsErrorClear = this.fetchScopeQuestionsErrorClear.bind(this);
        this.testDataQuestions = this.testDataQuestions.bind(this);

        this.saveQuestion = this.saveQuestion.bind(this);
        this.saveDetailQuestion = this.saveDetailQuestion.bind(this);

        this.questionEdit = this.questionEdit.bind(this)
        this.questionEditVerify = this.questionEditVerify.bind(this)

        this.cancelScopeQuestions = this.cancelScopeQuestions.bind(this);
        this.closeScopeQuestions = this.closeScopeQuestions.bind(this);

        this.questionDelete = this.questionDelete.bind(this);
        this.questionDeleteVerify = this.questionDeleteVerify.bind(this);

        this.addScopeQuestion = this.addScopeQuestion.bind(this);
        this.updateScopeQuestionDetail = this.updateScopeQuestionDetail.bind(this);
        this.closeScopeQuestionAdd = this.closeScopeQuestionAdd.bind(this);
        this.closeScopeQuestionAddDetail = this.closeScopeQuestionAddDetail.bind(this);

        this.startViewQuestion = this.startViewQuestion.bind(this);

        // options
        this.optionDelete = this.optionDelete.bind(this);
        this.optionDeleteVerify = this.optionDeleteVerify.bind(this);

        this.saveQuestionOption = this.saveQuestionOption.bind(this);
        this.saveDetailQuestionOption = this.saveDetailQuestionOption.bind(this);

        this.optionsEdit = this.optionsEdit.bind(this);
        this.cancelScopeQuestionOptions = this.cancelScopeQuestionOptions.bind(this);

        this.addScopeQuestionOption = this.addScopeQuestionOption.bind(this);
        this.closeScopeQuestionOptionAdd = this.closeScopeQuestionOptionAdd.bind(this);

        this.updateScopeQuestionDetailOption = this.updateScopeQuestionDetailOption.bind(this);
        this.closeScopeQuestionAddDetailOption = this.closeScopeQuestionAddDetailOption.bind(this);

        // deletes
        this.confirmDeleteNo = this.confirmDeleteNo.bind(this);
        this.confirmDeleteYes = this.confirmDeleteYes.bind(this);

        this.confirmDeleteTabNo = this.confirmDeleteTabNo.bind(this);
        this.confirmDeleteTabYes = this.confirmDeleteTabYes.bind(this);

        this.confirmDeleteQuestionNo = this.confirmDeleteQuestionNo.bind(this);
        this.confirmDeleteQuestionYes = this.confirmDeleteQuestionYes.bind(this);

        this.confirmDeleteQuestionOptionNo = this.confirmDeleteQuestionOptionNo.bind(this);
        this.confirmDeleteQuestionOptionYes = this.confirmDeleteQuestionOptionYes.bind(this);
    }

    afterOpen() {
        if (this.state.editScope) {
            let scope = this.state.scope

            scope.instructions = this.props.scope.scope.instructions
            scope.parties = this.props.scope.scope.parties
            scope.proposal = this.props.scope.scope.proposal

            this.setState({ scope: scope })

            if (this.state.viewScope) {
                setTimeout(function () {
                    var numEditors = $(document.getElementsByTagName('iframe')).length

                    for (var i = 0; i < numEditors; i++) {
                        $(document.getElementsByTagName('iframe')[i].contentDocument.getElementsByTagName('body')).css('background', '#ebebe4')
                        $(document.getElementsByTagName('iframe')[i].contentDocument.getElementsByTagName('body')).attr('contenteditable', 'false')
                    }
                }, 500)
            }
        }

        this.scopeNameChk()
    }
    afterOpenQuestions() {
        $('div.newquestion > input#questionlabel').val("")
        $('div.newquestion select#questiontype').val("Select")
        $('div.newquestion div.newinstructions').css('display', 'none')
        $('div.newquestion input#questiontext').val("")
        $('div.newquestion input#questionorder').val("")
        $('div.newquestion input#questionrequired').prop('checked', false)
        $('div.newquestion input#questionactive').prop('checked', false)    
    }

    scopeNameChk() {
        if ($('div.newquestion input#scopename').val() == "") {
            $('div.newquestion input#scopename').addClass('error')
            $('button.sow').attr('disabled', 'disabled')
        }
        else {
            $('div.newquestion input#scopename').removeClass('error')
            $('button.sow').removeAttr('disabled')
        }
    }

    fetchScopeErrorClear() {
        this.props.dispatch(fetchScopeError);
    }
    errorScopeClear(e) {
        this.props.dispatch(errorScope);

        if (this.props.scope.error === "409") {
            let id = e.target.attributes.scope.value;

            fetchScope.bind(this)(id);
        }
    }
    errorNoDataClear() {
        this.props.dispatch(clearNoDataError);
    }

    scopeView(e) {
        if (this.props.scopes.fetching) return

        this.setState({ viewScope: true })
        this.scopeEdit(e)
    }

    hdrToggle(e) {
        if (e.target.className.includes('down')) {
            $('div.instructions').css('display', 'block')
            e.target.className = "fa fa-toggle-up pull-right"
        }
        else {
            $('div.instructions').css('display', 'none')
            e.target.className = "fa fa-toggle-down down pull-right"
        }
    } 

    scopeEdit(e) {

        if (chkReturn || this.props.scopes.fetching) return;
        chkReturn = 1;

        let id = e.target.attributes.scope.value;
        let name = e.target.attributes.scopename.value;

        this.setState({
            scope: {
                projectTypeId: 0,
                active: false,
                name: "",
                order: 0,
                instructions: "",
                parties: "",
                proposal: "",
                deleted: false
            },
            scopeid: id,
            scopename: name
        });

        fetchScope.bind(this)(id);

        chkReturn = setInterval(this.scopeEditVerify, 100);
    }
    scopeEditVerify() {
        if (this.props.scope.updated || this.props.scope.error) {
            if (this.props.scope.updated) {
                this.setState({
                    editScope: true,
                    editScopeMode: true
                });

                $('.navbar-static-top').css('z-index', 0);
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    scopeCreate() {
        if (this.props.scopes.fetching) return

        let emptyscope = {
            projectTypeId: 0,
            active: false,
            name: "",
            order: 0,
            instructions: "",
            parties: "",
            proposal: "",
            deleted: false
        };

        this.setState({
            scope: emptyscope,
            editScope: false,
            editScopeMode: true
        });
    }

    scopeDelete(e) {
        if (this.props.scopes.fetching) return

        this.setState({
            confirmDelete: true,
            scopeid: e.target.attributes.scope.value, 
        })
    }
    scopeDeleteVerify() {
        if (this.props.scope.updated || this.props.scope.error) {

            if (this.props.scope.updated) {
                this.props.dispatch(fetchScopesList);
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    updateScope(e) {
        $('button.sow').attr('disabled', 'disabled')

        let create = e.target.attributes.create.value;
        let scope = {
            active: $('#active').is(':checked'),
            name: $('#scopename').val(),
            order: $('#order').val(),
            instructions: this.state.scope.instructions,
            parties: this.state.scope.parties,
            proposal: this.state.scope.proposal,
            deleted: false
        };

        if (create === 'true') {
            createScope.bind(this)(scope)
        }
        else {
            scope.projectTypeId = this.props.scope.scope.projectTypeId
            scope.deleted = this.props.scope.scope.deleted
            updateScope.bind(this)(scope.projectTypeId, scope)
        }

        chkReturn = setInterval(this.closeScope, 100)
    }
    updateScopeEdit(e) {
        $('button.sow').attr('disabled', 'disabled')

        let create = e.target.attributes.create.value;
        let scope = {
            active: $('#active').is(':checked'),
            name: $('#scopename').val(),
            order: $('#order').val(),
            instructions: this.state.scope.instructions,
            parties: this.state.scope.parties,
            proposal: this.state.scope.proposal,
            deleted: false
        };

        if (create === 'true') {
            createScope.bind(this)(scope)
        }
        else {
            scope.projectTypeId = this.props.scope.scope.projectTypeId
            scope.deleted = this.props.scope.scope.deleted
            updateScope.bind(this)(scope.projectTypeId, scope)
        }

        chkReturn = setInterval(this.closeScopeEdit, 100)
    }

    cancelScope() {
        this.props.dispatch(errorScope);

        this.setState({
            viewScope: false,
            editScopeMode: false
        });
    }
    closeScope() {
        if (this.props.scope.updated || this.props.scope.error) {
            $('button.sow').removeAttr('disabled')

            if (this.props.scope.updated) {
                this.cancelScope();

                this.props.dispatch(fetchScopesList);
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }
    closeScopeEdit() {
        if (this.props.scope.updated || this.props.scope.error) {
            $('button.sow').removeAttr('disabled')

            clearInterval(chkReturn);
            chkReturn = 0;

            if (this.props.scope.updated) {
                this.props.dispatch(fetchScopesList)

                this.setState({
                    scopeid: this.props.scope.scope.projectTypeId,
                    scopename: this.props.scope.scope.name
                })

                fetchScopeTabsList.bind(this)(this.props.scope.scope.projectTypeId);

                chkReturn = setInterval(this.scopeEditTabsVerify, 100);
            }
        }
    }

    sortColumn(e) {
        let sortOrder
        let sortElement = e.target.children.length === 0 ? e.target.parentElement : e.target
        let sortBy = sortElement.id
        let sort = sortElement.children[0].className.split(' ')[1]

        if (sort === "fa-sort") {
            sortOrder = "Ascending"
            sortElement.children[0].className = "fa fa-sort-asc fa-xs"
        }
        else if (sort === "fa-sort-asc") {
            sortOrder = "Descending"
            sortElement.children[0].className = "fa fa-sort-desc fa-xs"
        }
        else {
            sortOrder = "Ascending"
            sortElement.children[0].className = "fa fa-sort-asc fa-xs"
        }

        this.setState(
            {
                sortBy: sortBy,
                sortOrder: sortOrder
            }
        );

        $('th').each(function () {
            if ($(this).attr('id') !== sortElement.id) {
                $(this).removeClass("sort")
                $($(this).children()[0]).removeClass("fa-sort-asc")
                $($(this).children()[0]).removeClass("fa-sort-desc")
                $($(this).children()[0]).addClass("fa-sort")
            }
        })

        sortElement.className = "sort"
    }

    testData(e) {
        if (e.target.value.length)
            e.target.className = "newtab"
        else
            e.target.className = "newtab error"

        if ($('input#tabname').val() == "" || $('input#taborder').val() == "")
            $('button.save').attr('disabled', 'disabled')
        else
            $('button.save').removeAttr('disabled')
    }
    testDetailData(e) {
        var error = false

        if (e.target.value.length)
            e.target.className = "tab"
        else {
            error = true
            e.target.className = "tab error"
        }

        if (error)
            $('button[save=' + e.target.attributes.tab.value + ']').attr('disabled', 'disabled')
        else
            $('button[save=' + e.target.attributes.tab.value + ']').removeAttr('disabled')
    }
    testDataQuestions(e) {
        if (e.target.value.length && e.target.value !== 'Select')
            e.target.className = "newquestion"
        else
            e.target.className = "newquestion error"

        if ($('select#questiontype').val() == "LI" || $('select#questiontype').val() == "RI")
            $('div.newinstructions').css('display', 'block')
        else
            $('div.newinstructions').css('display', 'none')

        if ($('input#questionlabel').val() == "" ||
            $('select#questiontype').val() == "Select" ||
            $('input#questionorder').val() == "")
            $('button.save.newquestion').attr('disabled', 'disabled')
        else
            $('button.save.newquestion').removeAttr('disabled')
    }
    testDetailDataQuestions(e) {
        var error = false

        if (e.target.value.length && e.target.className.includes("error")) {
            e.target.className = e.target.className.replace("error", "")
        }
        else if (!e.target.value.length) {
            error = true
            e.target.className += " error"
        }

        if (e.target.value == 'Select') {
            error = true
            e.target.className = "detailquestion error"
        }

        if ($('select[questionindex=' + e.target.attributes.questionindex.value + ']').val() == 'LI' ||
            $('select[questionindex=' + e.target.attributes.questionindex.value + ']').val() == 'RI') {
            $('div.instructions[questionindex=' + e.target.attributes.questionindex.value + ']').css('display', 'block')
        }
        else {
            $('div.instructions[questionindex=' + e.target.attributes.questionindex.value + ']').css('display', 'none')
        }

        if (error)
            $('button.save[questionindex=' + e.target.attributes.questionindex.value + ']').attr('disabled', 'disabled')
        else
            $('button.save[questionindex=' + e.target.attributes.questionindex.value + ']').removeAttr('disabled')
    }
    testDataQuestionOption(e) {
        if (e.target.value.length)
            e.target.className = "newoption"
        else
            e.target.className = "newoption error"

        if ($('input#newquestionoption').val() == "" || $('input#newquestionorder').val() == "")
            $('button.save.newoption').attr('disabled', 'disabled')
        else
            $('button.save.newoption').removeAttr('disabled')
    }

    instructionsChange(editor) {
        editor.on('keyup', (e) => {
            let scope = this.state.scope

            scope.instructions = e.target.innerHTML
            this.setState({ scope: scope })
        })

        editor.on('change', (e) => {
            let scope = this.state.scope

            scope.instructions = e.level.content
            this.setState({ scope: scope })
        })
    }
    instructionsChangeQuestions(editor) {
        editor.on('keyup', (e) => {
            let instructions = this.state.instructions

            instructions[0] = e.target.innerHTML
            this.setState({ instructions: instructions })
        })

        editor.on('change', (e) => {
            let instructions = this.state.instructions

            instructions[0] = e.level.content
            this.setState({ instructions: instructions })
        })
    }

    partiesChange(editor) {
        editor.on('keyup', (e) => {
            let scope = this.state.scope

            scope.parties = e.target.innerHTML
            this.setState({ scope: scope })
        })

        editor.on('change', (e) => {
            let scope = this.state.scope

            scope.parties = e.level.content
            this.setState({ scope: scope })
        })
    }

    proposalChange(editor) {
        editor.on('keyup', (e) => {
            let scope = this.state.scope

            scope.proposal = e.target.innerHTML
            this.setState({ scope: scope })
        })

        editor.on('change', (e) => {
            let scope = this.state.scope

            scope.proposal = e.level.content
            this.setState({ scope: scope })
        })
    }

    // tabs
    scopeEditTabs(e) {

        if (chkReturn || this.props.scopes.fetching) return;
        chkReturn = 1;

        let id = e.target.attributes.scope.value;
        let name = e.target.attributes.scopename.value;

        this.setState({
            scopeid: id,
            scopename: name
        })

        fetchScopeTabsList.bind(this)(id);

        chkReturn = setInterval(this.scopeEditTabsVerify, 100);
    }
    scopeEditTabsVerify() {
        if (this.props.scope.updatedTabs || this.props.scope.errorTabs) {
            if (this.props.scope.updatedTabs) {
                this.setState({
                    editScopeTabsMode: true
                });
            }

            clearInterval(chkReturn);
            chkReturn = 0;

            this.cancelScope()
        }
    }

    updateScopeTabs() {
        $('button.save').attr('disabled', 'disabled')

        let tab = {
            name: $('input#tabname').val(),
            tabOrder: $('input#taborder').val(),
            deleted: false,
            active: $('input#tabactive').prop('checked')
        };

        updateScopeTabs.bind(this)(this.state.scopeid, tab)

        chkReturn = setInterval(this.closeScopeTabsAdd, 100)
    }
    updateScopeDetailTab(e) {
        var ndx = e.target.attributes.save.value

        e.target.attributes.disabled = "disabled"

        this.setState({ detailTab: ndx })

        let tab = {
            name: $('input[tabname=' + ndx + ']').val(),
            tabOrder: $('input[taborder=' + ndx + ']').val(),
            deleted: false,
            active: $('input[tabactive=' + ndx + ']').prop('checked')
        };

        updateScopeTab.bind(this)(this.state.scopeid, e.target.attributes.tab.value, tab)

        chkReturn = setInterval(this.closeScopeTab, 100)
    }

    cancelScopeTabs() {
        this.props.dispatch(errorScopeTabs);

        $('div.newtab').css('display', 'none')

        this.props.dispatch(fetchScopesList);

        this.setState({
            editScopeTabsMode: false
        });
    }
    closeScopeTab() {
        if (this.props.scope.updatedTabs || this.props.scope.errorTabs) {

            if (this.props.scope.updatedTabs) {
                $('button[save=' + this.state.detailTab + ']').removeAttr('disabled')
                $('tr.detail[tab=' + this.state.detailTab + ']').css('display', 'none')  

                setTimeout(function () {
                    for (var i = 0; i < $('tr.tab').length; i++) {
                        $('input[tabname=' + i + ']').val($($($('tr.tab')[i]).children()[1]).text())
                        $('input[taborder=' + i + ']').val($($($('tr.tab')[i]).children()[2]).text())
                        $('input[tabactive=' + i + ']').prop('checked', $($($('tr.tab')[i]).children()[1]).attr('active') == "1" ? true : false)
                    }
                }, 100);
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }
    closeScopeTabsAdd() {
        if (this.props.scope.updatedTabs || this.props.scope.errorTabs) {

            if (this.props.scope.updatedTabs) {
                this.stopTab()
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    fetchScopeTabsErrorClear() {
        this.props.dispatch(fetchScopeTabsError);
        this.props.dispatch(errorScopeTabs);
    }
    errorScopeTabsClear(e) {
        this.props.dispatch(errorScopeTabs);

        if (this.props.scope.errorTabs === "409") {
            let id = e.target.attributes.tab.value;

            fetchScopeTabsList.bind(this)(id);
        }
    }

    viewToggle(e) {
        if (e.target.className.includes('down')) {
            e.target.className = "fa fa-toggle-up pull-right"

            $('div.viewcore[tab=' + e.target.attributes.tabindex.value + ']').css('display', 'block')
        }
        else {
            e.target.className = "fa fa-toggle-down down pull-right"

            $('div.viewcore[tab=' + e.target.attributes.tabindex.value + ']').css('display', 'none')
        }
    } 

    startTab() {
        $('div.newtab').css('display', 'block')
        $('button.save').attr('disabled', 'disabled')
        $('button#starttab').attr('disabled', 'disabled')

        $('input.newtab').val('')
        $('input#tabactive').prop('checked', false)  
    }
    tabDelete(e) {
        this.setState({
            confirmDeleteTab: true,
            tabid: e.target.attributes.tab.value,
        })

    }
    tabDeleteVerify() {
        if (this.props.scope.updatedTabs || this.props.scope.errorTabs) {

            if (this.props.scope.updatedTabs) {
                fetchScopeTabsList.bind(this)(this.state.scopeid);
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    startDetailTab(e) {
        if ($('tr.view[tab=' + e.target.attributes.tabindex.value + ']').hasClass('edittab'))
            return

        if ($('tr.detail[tab=' + e.target.attributes.tabindex.value + ']').hasClass('viewtab')) {
            $('tr.detail[tab=' + e.target.attributes.tabindex.value + ']').removeClass('viewtab')

            $('tr.view[tab=' + e.target.attributes.tabindex.value + ']').css('display', 'none')
        }

        $('input[tabname=' + e.target.attributes.tabindex.value + ']').val($($($('tr.tab')[e.target.attributes.tabindex.value]).children()[1]).text())
        $('input[taborder=' + e.target.attributes.tabindex.value + ']').val($($($('tr.tab')[e.target.attributes.tabindex.value]).children()[2]).text())
        $('input[tabactive=' + e.target.attributes.tabindex.value + ']').prop('checked', $($($('tr.tab')[e.target.attributes.tabindex.value]).children()[1]).attr('active') == "1" ? true : false)

        $('tr.view[tab=' + e.target.attributes.tabindex.value + ']').addClass('edittab')

        $('tr.detail[tab=' + e.target.attributes.tabindex.value + ']').css('display', 'table-row')
    }
    startViewTab(e) {
        if ($('tr.detail[tab=' + e.target.attributes.tabindex.value + ']').hasClass('viewtab'))
            return

        if ($('tr.view[tab=' + e.target.attributes.tabindex.value + ']').hasClass('edittab')) {
            $('tr.view[tab=' + e.target.attributes.tabindex.value + ']').removeClass('edittab')

            $('tr.detail[tab=' + e.target.attributes.tabindex.value + ']').css('display', 'none')
        }

        $('tr.detail[tab=' + e.target.attributes.tabindex.value + ']').addClass('viewtab')

        this.setState({ tabindex: e.target.attributes.tabindex.value })

        fetchScopeQuestionsList.bind(this)(
            {
                id: e.target.attributes.tab.value,
                ndx: e.target.attributes.tabindex.value
            }
        );

        chkReturn = setInterval(this.startViewTabVerify, 100);
    }
    startViewTabVerify() {
        if (this.props.scope.errorQuestions ||
            (this.props.scope.tabndx != -1 && (this.props.scope.tabs[this.props.scope.tabndx].rcvOptQuestions == this.props.scope.tabs[this.props.scope.tabndx].numOptQuestions))) {
 
            if (this.props.scope.updatedQuestions) 
                $('tr.view[tab=' + this.state.tabindex + ']').css('display', 'table-row')
            else 
                $('tr.detail[tab=' + this.state.tabindex + ']').removeClass('viewtab')

            if ($($('div.viewcore[tab=' + this.state.tabindex + ']')[0]).height() < $($('div.viewcore[tab=' + this.state.tabindex + ']')[1]).height())
                $($('div.viewcore[tab=' + this.state.tabindex + ']')[0]).css('margin-top', $($('div.viewcore[tab=' + this.state.tabindex + ']')[1]).height().toString() + 'px')

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    stopTab() {
        $('div.newtab').css('display', 'none')
        $('button#starttab').removeAttr('disabled')
    }
    stopDetailTab(e) {
        $('tr.view[tab=' + e.target.attributes.cancel.value + ']').removeClass('edittab')

        $('tr.detail[tab='+ e.target.attributes.cancel.value + ']').css('display', 'none')
    }
    stopViewTab(e) {
        $('tr.detail[tab=' + e.target.attributes.cancel.value + ']').removeClass('viewtab')

        $('tr.view[tab=' + e.target.attributes.cancel.value + ']').css('display', 'none')
    }

    saveTab() {
        this.updateScopeTabs()
    }
    saveDetailTab(e) {
        this.updateScopeDetailTab(e)
    }

    // questions
    fetchScopeQuestionsErrorClear() {
        this.props.dispatch(fetchScopeQuestionsError);
    }

    questionEdit(e) {

        if (chkReturn) return;
        chkReturn = 1;

        let id = e.target.attributes.tab.value
        let name = e.target.attributes.tabname.value
        let index = e.target.attributes.tabindex.value
        let scope = this.state.scope

        scope.instructions = ""

        this.setState({
            tabid: id,
            tabindex: index,
            tabname: name,
            scope: scope
        })

        fetchScopeQuestionsList.bind(this)(
            {
                id: id,
                ndx: index
            }
        );

        chkReturn = setInterval(this.questionEditVerify, 100);
    }
    questionEditVerify() {
        if (this.props.scope.errorQuestions ||
            (this.props.scope.tabndx != -1 && (this.props.scope.tabs[this.props.scope.tabndx].rcvOptQuestions == this.props.scope.tabs[this.props.scope.tabndx].numOptQuestions))) {
            if (this.props.scope.updatedQuestions) {
                this.setState({
                    editScopeQuestionsMode: true
                });
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    cancelScopeQuestions() {
        $('div.newquestion').css('display', 'none')

        this.setState({
            editScopeQuestionsMode: false
        });
    }
    closeScopeQuestions() {
        if (this.props.scope.updatedQuestions || this.props.scope.errorQuestions) {

            if (this.props.scope.updatedQuestions) {
                this.cancelScopeQuestions()
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    startQuestion() {
        $('div.newquestion').css('display', 'block')
        $('button.save.newquestion').attr('disabled', 'disabled')
        $('button#startquestion').attr('disabled', 'disabled')

        $('input.newquestion').val('')
        $('select.newquestion').val('Select')
        $('div.newinstructions').css('display', 'none')
        $('#questionlabel').addClass('error')
        $('#questiontype').addClass('error')
        $('#questionorder').addClass('error')
        $('input#questionrequired').prop('checked', false)
        $('input#questionactive').prop('checked', false)
    }
    questionDelete(e) {
        this.setState({
            confirmDeleteQuestion: true,
            questionid: e.target.attributes.question.value,
        })

    }
    questionDeleteVerify() {
        if (this.props.scope.updatedTabs || this.props.scope.errorTabs) {
            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    startDetailQuestion(e) {
        if ($('tr.detail[questionindex=' + e.target.attributes.questionindex.value + ']').hasClass('viewquestion')) {
            $('tr.detail[questionindex=' + e.target.attributes.questionindex.value + ']').removeClass('viewquestion')

            $('tr.view[questionindex=' + e.target.attributes.questionindex.value + ']').css('display', 'none')
        }

        $('input.lbl[questionindex=' + e.target.attributes.questionindex.value + ']').val($('input.lbl[questionindex=' + e.target.attributes.questionindex.value + ']').attr('defval'))
        $('select.type[questionindex=' + e.target.attributes.questionindex.value + ']').val($('select.type[questionindex=' + e.target.attributes.questionindex.value + ']').attr('defval'))
        $('input.help[questionindex=' + e.target.attributes.questionindex.value + ']').val($('input.help[questionindex=' + e.target.attributes.questionindex.value + ']').attr('defval'))
        $('input.order[questionindex=' + e.target.attributes.questionindex.value + ']').val($('input.order[questionindex=' + e.target.attributes.questionindex.value + ']').attr('defval'))

        var chk = $('input.required[questionindex=' + e.target.attributes.questionindex.value + ']').attr('checked')
        $('input.required[questionindex=' + e.target.attributes.questionindex.value + ']').prop('checked', chk == undefined ? false : true)

        chk = $('input.active[questionindex=' + e.target.attributes.questionindex.value + ']').attr('checked')
        $('input.active[questionindex=' + e.target.attributes.questionindex.value + ']').prop('checked', chk == undefined ? false : true)

        $('tr.view[questionindex=' + e.target.attributes.questionindex.value + ']').addClass('editquestion')

        $('tr.detail[questionindex=' + e.target.attributes.questionindex.value + ']').css('display', 'table-row')

        $('button[questionindex=' + e.target.attributes.questionindex.value + ']').removeAttr('disabled')

        if ($('select[questionindex=' + e.target.attributes.questionindex.value + ']').val() == "LI" ||
            $('select[questionindex=' + e.target.attributes.questionindex.value + ']').val() == "RI")
            $('div.instructions[questionindex=' + e.target.attributes.questionindex.value + ']').css('display', 'block')
        else
            $('div.instructions[questionindex=' + e.target.attributes.questionindex.value + ']').css('display', 'none')
    }
    startViewQuestion(e) {
        if ($('tr.view[questionindex=' + e.target.attributes.questionindex.value + ']').hasClass('editquestion')) {
            $('tr.view[questionindex=' + e.target.attributes.questionindex.value + ']').removeClass('editquestion')

            $('tr.detail[questionindex=' + e.target.attributes.questionindex.value + ']').css('display', 'none')
        }

        $('tr.detail[questionindex=' + e.target.attributes.questionindex.value + ']').addClass('viewquestion')

        this.setState({ questionindex: e.target.attributes.questionindex.value })

        setTimeout(() => {
            $('tr.view[questionindex=' + this.state.questionindex + ']').css('display', 'table-row')

            if ($($('div.viewelement[questionindex=' + this.state.questionindex + ']')[0]).height() < $($('div.viewelement[questionindex=' + this.state.questionindex + ']')[1]).height())
                $($('div.viewelement[questionindex=' + this.state.questionindex + ']')[0]).css('margin-top', $($('div.viewelement[questionindex=' + this.state.questionindex + ']')[1]).height().toString() + 'px')
        }, 100);
    }

    stopQuestion() {
        $('div.newquestion').css('display', 'none')
        $('button#startquestion').removeAttr('disabled')
    }
    stopDetailQuestion(e) {
        $('tr.view[questionindex=' + e.target.attributes.cancel.value + ']').removeClass('editquestion')

        $('tr.detail[questionindex=' + e.target.attributes.cancel.value + ']').css('display', 'none')
    }
    stopViewQuestion(e) {
        $('tr.detail[questionindex=' + e.target.attributes.cancel.value + ']').removeClass('viewquestion')

        $('tr.view[questionindex=' + e.target.attributes.cancel.value + ']').css('display', 'none')
    }

    saveQuestion() {
        this.addScopeQuestion()
    }
    saveDetailQuestion(e) {
        this.updateScopeQuestionDetail(e)
    }

    addScopeQuestion() {
        $('button.save').attr('disabled', 'disabled')

        let question = {
            label: $('input#questionlabel').val(),
            type: $('select#questiontype').val(),
            helpText: $('input#questiontext').val(),
            instructions: this.state.scope.instructions,
            order: $('input#questionorder').val(),
            required: $('input#questionrequired').prop('checked'),
            active: $('input#questionactive').prop('checked'),
            deleted: false
        };

        addTabQuestion.bind(this)(this.state.tabid, question)

        chkReturn = setInterval(this.closeScopeQuestionAdd, 100)
    }
    updateScopeQuestionDetail(e) {
        var ndx = e.target.attributes.save.value

        e.target.attributes.disabled = "disabled"

        this.setState({ detailQuestion: ndx })

        let question = {
            label: $('input.lbl[questionindex=' + ndx + ']').val(),
            type: $('select.type[questionindex=' + ndx + ']').val(),
            helpText: $('input.help[questionindex=' + ndx + ']').val(),
            instructions: this.state.instructions[0],
            order: $('input.order[questionindex=' + ndx + ']').val(),
            required: $('input.required[questionindex=' + ndx + ']').prop('checked'),
            active: $('input.active[questionindex=' + ndx + ']').prop('checked'),
            deleted: false
        };

        updateTabQuestionDetail.bind(this)(this.state.tabid, e.target.attributes.question.value, ndx, question)

        chkReturn = setInterval(this.closeScopeQuestionAddDetail, 100)
    }

    closeScopeQuestionAdd() {
        if (this.props.scope.updatedQuestions || this.props.scope.errorQuestions) {

            $('button.save').removeAttr('disabled')

            if (this.props.scope.updatedQuestions)
                this.stopQuestion()

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }
    closeScopeQuestionAddDetail() {
        if (this.props.scope.updatedQuestions || this.props.scope.errorQuestions) {

            if (this.props.scope.updatedQuestions) {
                $('tr.view[questionindex=' + this.state.detailQuestion + ']').removeClass('editquestion')

                $('tr.detail[questionindex=' + this.state.detailQuestion + ']').css('display', 'none')

                setTimeout(function () {
                    for (var i = 0; i < $('tr.detail').length; i++) {
                        $('input.lbl[questionindex=' + i + ']').val($('input.lbl[questionindex=' + i + ']').attr('defval'))
                        $('select.type[questionindex=' + i + ']').val($('select.type[questionindex=' + i + ']').attr('defval'))

                        if ($('select.type[questionindex=' + i + ']').val() == 'LI' || $('select.type[questionindex=' + i + ']').val() == 'RI')
                            $('div.instructions[questionindex=' + i + ']').css('display', 'block')
                        else
                            $('div.instructions[questionindex=' + i + ']').css('display', 'none')

                        $('input.help[questionindex=' + i + ']').val($('input.help[questionindex=' + i + ']').attr('defval'))
                        $('input.order[questionindex=' + i + ']').val($('input.order[questionindex=' + i + ']').attr('defval'))

                        $($('div.required[questionindex=' + i + ']').children[1]).prop('checked', $('div.required[questionindex=' + i + ']').attr('defval'))
                        $($('div.active[questionindex=' + i + ']').children[1]).prop('checked', $('div.active[questionindex=' + i + ']').attr('defval'))
                    }
                }, 100);
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    // options
    closeScopeQuestionAddDetailOption() {
        if (this.props.scope.updatedQuestions || this.props.scope.errorQuestions) {

            if (this.props.scope.updatedQuestions) {
                $('tr.detail[optionindex=' + this.state.detailQuestionOption + ']').css('display', 'none')

                setTimeout(function () {
                    for (var i = 0; i < $('tr.option').length; i++) {
                        $('input.option[optionindex=' + i + ']').attr('defval', $('input.option[optionindex=' + i + ']').val())
                        $('input.help[optionindex=' + i + ']').attr('defval', $('input.help[optionindex=' + i + ']').val())
                        $('input.order[optionindex=' + i + ']').attr('defval', $('input.order[optionindex=' + i + ']').val())
                    }
                }, 100);
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    updateScopeQuestionDetailOption(e) {
        var ndx = e.target.attributes.save.value

        e.target.attributes.disabled = "disabled"

        this.setState({ detailQuestionOption: ndx })

        let option = {
            optionName: $('input.option[optionindex=' + ndx + ']').val(),
            optionHelpText: $('input.help[optionindex=' + ndx + ']').val(),
            optionOrder: $('input.order[optionindex=' + ndx + ']').val()
        };

        updateTabQuestionDetailOption.bind(this)(this.state.questionid, e.target.attributes.option.value, ndx, option)

        chkReturn = setInterval(this.closeScopeQuestionAddDetailOption, 100)
    }

    saveQuestionOption() {
        this.addScopeQuestionOption()
    }
    saveDetailQuestionOption(e) {
        this.updateScopeQuestionDetailOption(e)
    }

    addScopeQuestionOption() {
        $('button.save').attr('disabled', 'disabled')

        let option = {
            optionName: $('input#newquestionoption').val(),
            optionHelpText: $('input#newquestionhelp').val(),
            optionOrder: $('input#newquestionorder').val()
        };

        addTabQuestionOption.bind(this)(this.state.questionid, option)

        chkReturn = setInterval(this.closeScopeQuestionOptionAdd, 100)
    }

    closeScopeQuestionOptionAdd() {
        if (this.props.scope.updatedQuestions || this.props.scope.errorQuestions) {

            $('input#newquestionoption').addClass('error')
            $('input#newquestionorder').addClass('error')

            $('button.save').removeAttr('disabled')
        
            if (this.props.scope.updatedQuestions) 
                this.stopQuestionOption()

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    optionsEdit(e) {
        this.setState({
            questionid: e.target.attributes.question.value,
            questionname: e.target.attributes.questionname.value,
            questiontype: e.target.attributes.questiontype.value,
            questionindex: e.target.attributes.questionindex.value,
            editScopeQuestionOptionsMode: true
        });
    }

    cancelScopeQuestionOptions() {
        $('div.newoption').css('display', 'none')

        this.setState({
            editScopeQuestionOptionsMode: false
        });
    }

    startQuestionOption() {
        $('div.newoption').css('display', 'block')
        $('button.save.newoption').attr('disabled', 'disabled')
        $('button#startoption').attr('disabled', 'disabled')

        $('input.newoption').val('')
    }

    optionDelete(e) {
        this.setState({
            confirmDeleteQuestionOption: true,
            questionoptionid: e.target.attributes.option.value,
        })
    }
    optionDeleteVerify() {
        if (this.props.scope.updatedQuestions || this.props.scope.errorQuestions) {
            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    startDetailOption(e) {
        $('input.option[optionindex=' + e.target.attributes.optionindex.value + ']').val($('input.option[optionindex=' + e.target.attributes.optionindex.value + ']').attr('defval'))
        $('input.help[optionindex=' + e.target.attributes.optionindex.value + ']').val($('input.help[optionindex=' + e.target.attributes.optionindex.value + ']').attr('defval'))
        $('input.order[optionindex=' + e.target.attributes.optionindex.value + ']').val($('input.order[optionindex=' + e.target.attributes.optionindex.value + ']').attr('defval'))

        $('tr.detail[optionindex=' + e.target.attributes.optionindex.value + ']').css('display', 'table-row')

        $('button[optionindex=' + e.target.attributes.optionindex.value + ']').removeAttr('disabled')
    }
 
    stopQuestionOption() {
        $('div.newoption').css('display', 'none')
        $('button#startoption').removeAttr('disabled')
    }

    stopDetailOption(e) {
        $('tr.detail[optionindex=' + e.target.attributes.cancel.value + ']').css('display', 'none')
    }

    // confirm deletes
    confirmDeleteNo() {
        this.setState({ confirmDelete: false })
    }
    confirmDeleteYes(e) {
        deleteScope.bind(this)(this.state.scopeid);

        chkReturn = setInterval(this.scopeDeleteVerify, 100);

        this.confirmDeleteNo()
    }

    confirmDeleteTabNo() {
        this.setState({ confirmDeleteTab: false })
    }
    confirmDeleteTabYes(e) {
        deleteTab.bind(this)(this.state.tabid);

        chkReturn = setInterval(this.tabDeleteVerify, 100);

        this.confirmDeleteTabNo()
    }

    confirmDeleteQuestionNo() {
        this.setState({ confirmDeleteQuestion: false })
    }
    confirmDeleteQuestionYes(e) {
        deleteQuestion.bind(this)(this.state.questionid);

        chkReturn = setInterval(this.questionDeleteVerify, 100);

        this.confirmDeleteQuestionNo()
    }

    confirmDeleteQuestionOptionNo() {
        this.setState({ confirmDeleteQuestionOption: false })
    }
    confirmDeleteQuestionOptionYes(e) {
        deleteOption.bind(this)(this.state.questionoptionid);

        chkReturn = setInterval(this.optionDeleteVerify, 100);

        this.confirmDeleteQuestionOptionNo()
    }

    render() {
        return (
            <div className="scope col-xs-12">
                <div className="headWrapper">
                    <div className="scope">
                        <h1>Scope of Work Admin</h1>
                    </div>
                    <div className="scope">
                        <span>Manage your data in the box provided below, click create SOW Project Type to create a new record</span>
                        <button className="btn btn-primary pull-right" onClick={this.scopeCreate}>+ Create SOW Project Type</button>
                    </div>
                </div>

                <CommError error={this.props.scopes.error} onClose={this.fetchScopeErrorClear} />
                <CommError error={this.props.scope.error} onClose={this.errorScopeClear} />

                <ConfirmModal open={this.props.scopes.noData} heading={"Scope of Work Admin"} msg={"No Records"} notifyOnly={true} onYes={this.errorNoDataClear} />
                <ConfirmModal open={this.state.confirmDelete} heading={"Delete Project Type"} msg={"Are you sure you want to delete this project type?"} onNo={this.confirmDeleteNo} onYes={this.confirmDeleteYes} />

                <div className="tableWrapper">
                    {
                        this.props.scopes.fetching ?
                            <Spinner name='line-spin-fade-loader' />
                        :
                            null
                    }

                    <table className="lists table table-striped">
                        <thead>
                            <tr className="head">
                                <th id="id" onClick={this.sortColumn}>ID<i className="fa fa-sort fa-xs"></i></th>
                                <th id="name" onClick={this.sortColumn}>Scope Name<i className="fa fa-sort fa-xs"></i></th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.props.scopeList.sort((a, b) => {
                                    if (this.state.sortBy === 'id') {
                                        if (a.projectTypeId > b.projectTypeId)
                                            return this.state.sortOrder === 'Ascending' ? 1 : -1
                                        else if (a.projectTypeId < b.projectTypeId)
                                            return this.state.sortOrder === 'Ascending' ? -1 : 1
                                        else
                                            return 0
                                    }
                                    else {
                                        if (a.name > b.name)
                                            return this.state.sortOrder === 'Ascending' ? 1 : -1
                                        else if (a.name < b.name)
                                            return this.state.sortOrder === 'Ascending' ? -1 : 1
                                        else
                                            return 0
                                    }
                                })
                                .map((scope, index) => {
                                    return <tr className="body" key={index}>
                                        <td>{scope.projectTypeId}</td>
                                        <td scope={scope.projectTypeId} scopename={scope.name} onClick={this.scopeView}>{scope.name}</td>
                                        <td>
                                            <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>}>
                                                <i className="fa fa-edit" scope={scope.projectTypeId} scopename={scope.name} onClick={this.scopeEdit}></i>
                                            </OverlayTrigger>
                                            <OverlayTrigger placement="top" overlay={<Tooltip>Delete</Tooltip>}>
                                                <i className="fa fa-remove" scope={scope.projectTypeId} onClick={this.scopeDelete}></i>
                                            </OverlayTrigger>
                                            <span scope={scope.projectTypeId} scopename={scope.name} onClick={this.scopeEditTabs}>Edit Tabs</span>
                                        </td>
                                    </tr>
                                })
                            }
                        </tbody>
                    </table>
                </div>

                <CreateEditScope
                    errScope={this.props.scope}
                    errScopeClear={this.errorScopeClear}

                    curScope={this.props.scope.scope}
                    tmpScope={this.state.scope}

                    create={this.state.editScope}
                    isOpen={this.state.editScopeMode}
                    viewOnly={this.state.viewScope}
                    hdrToggle={this.hdrToggle}

                    scopeName={this.state.scopename}
                    scopeNameChk={this.scopeNameChk}

                    onInstructionsChange={this.instructionsChange}
                    onPartiesChange={this.partiesChange}
                    onProposalChange={this.proposalChange}

                    onAfterOpen={this.afterOpen}
                    onRequestClose={this.updateScope}
                    onRequestCloseEdit={this.updateScopeEdit}
                    onRequestCancel={this.cancelScope}
                />

                <EditScopeTabs
                    fetchScopeTabsErrorClear={this.fetchScopeTabsErrorClear}
                    errScopeTabs={this.props.scope}

                    curScopeTabs={this.props.scope.tabs}

                    isOpen={this.state.editScopeTabsMode}

                    scopeName={this.state.scopename}

                    viewToggle={this.viewToggle}

                    testData={this.testData}
                    testDetailData={this.testDetailData}

                    saveTab={this.saveTab}
                    saveDetailTab={this.saveDetailTab}

                    onDeleteTab={this.tabDelete}
                    confirmDeleteTab={this.state.confirmDeleteTab}
                    confirmDeleteTabYes={this.confirmDeleteTabYes}
                    confirmDeleteTabNo={this.confirmDeleteTabNo}

                    onStartTab={this.startTab}
                    onStartDetailTab={this.startDetailTab}
                    onStartViewTab={this.startViewTab}

                    onStopTab={this.stopTab}
                    onStopDetailTab={this.stopDetailTab}
                    onStopViewTab={this.stopViewTab}

                    onEditQuestion={this.questionEdit}

                    onRequestCancel={this.cancelScopeTabs}
                />

                {
                    this.props.scope.tabndx != -1 && (this.props.scope.tabs[this.props.scope.tabndx].rcvOptQuestions == this.props.scope.tabs[this.props.scope.tabndx].numOptQuestions) ?
                        <EditScopeTabQuestions
                            fetchScopeQuestionsErrorClear={this.fetchScopeQuestionsErrorClear}
                            errScopeQuestions={this.props.scope}

                            curScopeTabs={this.props.scope.tabs}
                            curScopeTab={this.props.scope.tabndx}

                            isOpen={this.state.editScopeQuestionsMode}

                            scopeName={this.state.scopename}
                            tabName={this.state.tabname}
                            questionName={this.state.questionname}

                            testData={this.testDataQuestions}
                            testDetailData={this.testDetailDataQuestions}

                            saveQuestion={this.saveQuestion}
                            saveDetailQuestion={this.saveDetailQuestion}

                            onDeleteQuestion={this.questionDelete}
                            confirmDeleteQuestion={this.state.confirmDeleteQuestion}
                            confirmDeleteQuestionYes={this.confirmDeleteQuestionYes}
                            confirmDeleteQuestionNo={this.confirmDeleteQuestionNo}

                            onStartQuestion={this.startQuestion}
                            onStartDetailQuestion={this.startDetailQuestion}
                            onStartViewQuestion={this.startViewQuestion}

                            onStopQuestion={this.stopQuestion}
                            onStopDetailQuestion={this.stopDetailQuestion}
                            onStopViewQuestion={this.stopViewQuestion}

                            onEditOptions={this.optionsEdit}

                            onInstructionsChange={this.instructionsChange}
                            onInstructionsChangeQuestions={this.instructionsChangeQuestions}

                            onAfterOpen={this.afterOpenQuestions}
                            onRequestCancel={this.cancelScopeQuestions}
                        />
                    : null
                }

                {
                    this.props.scope.tabndx != -1 && this.state.questionindex != -1 && (this.props.scope.tabs[this.props.scope.tabndx].rcvOptQuestions == this.props.scope.tabs[this.props.scope.tabndx].numOptQuestions) ?
                        <EditScopeTabQuestionOptions
                            errScopeOption={this.props.scope}
                            errScopeOptionClear={this.errorScopeOptionClear}

                            curScopeTabs={this.props.scope.tabs}
                            curScopeTab={this.props.scope.tabndx}
                            curScopeQuestion={this.state.questionindex}

                            isOpen={this.state.editScopeQuestionOptionsMode}

                            scopeName={this.state.scopename}
                            tabName={this.state.tabname}
                            questionName={this.state.questionname}

                            testData={this.testDataQuestionOption}
                            testDetailData={this.testDetailDataQuestionOption}

                            saveOption={this.saveQuestionOption}
                            saveDetailOption={this.saveDetailQuestionOption}

                            onDeleteOption={this.optionDelete}
                            confirmDeleteOption={this.state.confirmDeleteQuestionOption}
                            confirmDeleteOptionYes={this.confirmDeleteQuestionOptionYes}
                            confirmDeleteOptionNo={this.confirmDeleteQuestionOptionNo}

                            onStartOption={this.startQuestionOption}
                            onStartDetailOption={this.startDetailOption}

                            onStopOption={this.stopQuestionOption}
                            onStopDetailOption={this.stopDetailOption}

                            onRequestCancel={this.cancelScopeQuestionOptions}
                        />
                    : null
                }
            </div>
        );
    }
}

const mapStateToProps = state => ({
    scope: state.scope,
    scopes: state.scopes
});

export default connect(mapStateToProps)(Scope)